import styled from 'styled-components';

export const HorizontalLineStyled = styled.div`
  min-width: 100%;
  content: '';
  height: 1px;
  margin: 20px 0;
  background-color: rgba(0, 0, 0, 0.08);
`;
